import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetProducts as GetProductsQuery,
    GetProducts_products_edges_node as Product,
} from 'nutshell-graphql-types';

import GET_PRODUCTS from '../queries/get-products.graphql';

export const GET_PRODUCTS_LIMIT = 1000;

export const useGetProducts = (
    categoryId?: string | null,
    archived?: boolean | null
): {
    products: Product[];
    isLoading: boolean;
    hasNextPage: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
    fetchMore: () => Promise<any>;
} => {
    const {loading, data, error, refetch, fetchMore} = useQuery<GetProductsQuery, Record<any, any>>(
        GET_PRODUCTS,
        {
            fetchPolicy: 'cache-and-network',
            variables: {
                first: GET_PRODUCTS_LIMIT,
                categoryId,
                archived,
            },
        }
    );

    const hasNextPage =
        data && data.products && data.products.pageInfo && data.products.pageInfo.hasNextPage;
    const endCursor =
        data && data.products && data.products.pageInfo && data.products.pageInfo.endCursor;

    return {
        products:
            data && data.products && data.products.edges
                ? data.products.edges.map((edge) => edge.node)
                : [],
        isLoading: loading,
        hasNextPage: hasNextPage || false,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
        fetchMore: (shouldPaginate?: boolean) => {
            return fetchMore({
                query: GET_PRODUCTS,
                variables: {
                    first: GET_PRODUCTS_LIMIT,
                    after: shouldPaginate && endCursor,
                },
                // @ts-expect-error
                updateQuery: (previousResult, {fetchMoreResult}) => {
                    if (!fetchMoreResult || !previousResult) return;
                    // @ts-expect-error
                    if (!previousResult.products.pageInfo.hasNextPage) return;

                    return {
                        products: {
                            __typename: 'ProductsConnection',
                            // @ts-expect-error
                            pageInfo: fetchMoreResult.products.pageInfo,
                            edges: [
                                // @ts-expect-error
                                ...previousResult.products.edges,
                                // @ts-expect-error
                                ...fetchMoreResult.products.edges,
                            ],
                        },
                    };
                },
            });
        },
    };
};
